import React from 'react';
import { useSelector } from 'react-redux';
import { getCurrentCompanyId } from 'src/modules/companies/slices';
import { TextToWinWinners } from './TextToWinWinners';
import { useBuilderContext } from '../../context';

/**
 * Draw results, rendered only for a saved campaign that is not a duplicate — a
 * brand-new draft has no draw to show. The builder context's `campaignId` is
 * already scoped that way.
 */
export const TextToWinWinnersField: React.FC = () => {
  const { campaignId } = useBuilderContext();
  const companyId = useSelector(getCurrentCompanyId) as string;

  if (!campaignId || !companyId) return null;

  return <TextToWinWinners campaignId={campaignId} companyId={companyId} />;
};
